import React from "react";
import InputFactory from "../../../../../../components/InputFactory";

export default function StartDateModal({ object, onChange }) {
  return (
    <div className="col">
      <div className="row">
        <p className="fw-semibold text-primary" style={{ fontSize: "1.3rem" }}>
          Add Start Date
        </p>
        <div className="ps-2 pe-2">
          <InputFactory
            required
            object={object}
            onChange={onChange}
            type="Date"
            field="startDate"
          />
        </div>
      </div>
    </div>
  );
}
